import { Box, Text } from 'components/vensaComponents';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const Icon: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <Box
    width="18px"
    height="18px"
    borderRadius="50%"
    bg="white"
    border="1px solid"
    borderColor="primary"
    justifyContent="center"
    alignItems="center"
    ml="auto"
    cursor="pointer"
    onClick={() => onClick()}
  >
    <Text font-family={"initial"} color="primary">i</Text>
  </Box>
);

const TooltipBox = styled.span`
  position: absolute;
  top: calc(100% + 10px);
  left: 30px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: max-content;
  max-width: fit-content;
  padding: 8px 8px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 40px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
`

const Label = styled.div`
    font-size: 14px;
    color: #07A3C8;
    width: 90%;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    padding: 0.5rem 0;
    position: relative;

  & ${Label}:hover + ${TooltipBox} {
    visibility: visible;
    color: #fff;
    background-color: #07A3C8;
    width: max-content;
    padding: 8px 8px;
    z-index: 1;
    transition-delay:0.5s;
    &:before {
      border-color: transparent transparent #07A3C8
        #07A3C8;
    }
  }
`

const TooltipLine = styled.div`
    font-size: 14px;
    padding: 0.5rem 0;
`

interface IProps {
  text: string;
  tooltipText?: string[];
  date: string;
  onClick: (keyword: string) => void;
}

const ClickableItem: React.FC<IProps> = ({ text, tooltipText, date, onClick }) =>
  <Container >
    <Label>{text} {date ? `(${moment(date).format('DD/MM/YYYY')})` : ''}
    </Label>
    {tooltipText ? <TooltipBox>
      {(tooltipText.length ?? 0) > 0 ? tooltipText.map((item: any) =>
        <TooltipLine key={item}>{item}</TooltipLine>
      ) : null}
    </TooltipBox> : null}
    <Icon onClick={() => onClick(text)} />
  </Container>

export default ClickableItem;